/* eslint-disable jira/filename-case */
import type { RequestParameters, Variables } from 'relay-runtime';

export type RelayPromiseKey = string;
export const toRelayPromiseKey = (value: string): RelayPromiseKey => value;

export const EarlyScriptQueryPromisesMap: Map<string, Promise<Response>> = new Map<
	RelayPromiseKey,
	Promise<Response>
>();

export const getEarlyScriptPromiseKey = <TVariables extends Variables>(
	params: RequestParameters,
	variables: TVariables,
): RelayPromiseKey => {
	if (params.name === 'mainIssueAggQuery') {
		return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
	}
	const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;

	const serializedVariables =
		variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';

	return `${params.name}|${String(queryId)}|${serializedVariables}`;
};

// Due to the expected usecase that this map only be used for early script promises, to prevent abuse it is restricted to single use only. Once a key is claimed it may not be re-used
export const claimEarlyScriptPromise = (key: RelayPromiseKey): Promise<Response> | undefined => {
	const result = EarlyScriptQueryPromisesMap.get(key);
	if (result != null) {
		EarlyScriptQueryPromisesMap.delete(key);
	}
	return result;
};

// Due to the expected usecase that this map only be used for early script promises, to prevent abuse it is restricted to single use only. Once a key is claimed it may not be re-used
export const putEarlyScriptPromise = (key: RelayPromiseKey, promise: Promise<Response>): void => {
	if (!EarlyScriptQueryPromisesMap.has(key)) {
		EarlyScriptQueryPromisesMap.set(key, promise);
	}
};
